import { useState, useEffect, useRef } from "react";

const UserMenu = ({ userDetails, isCollapsed, SignOut }) => {
    console.log("userDetails", userDetails?.first_name);

    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    // Efecto para cerrar el menú al hacer clic fuera de él
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    useEffect(() => {
        if (isCollapsed) {
            setOpen(false);
        }
    }, [isCollapsed]);

    return (
        <div className="relative">
            {/* Botón principal */}
            <button
                ref={buttonRef}
                onClick={() => setOpen(!open)}
                className="flex items-center gap-2 text-white rounded-lg transition"
            >
                <img
                    className="w-9 h-9 rounded-[12px] border-2 border-[#E4E4E4] object-cover"
                    src="https://plus.unsplash.com/premium_photo-1689977968861-9c91dbb16049?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cHJvZmlsZSUyMHBpY3R1cmV8ZW58MHx8MHx8fDA%3D"
                    alt="Profile"
                />
                {userDetails && !isCollapsed && (
                    <span>Hola, {userDetails.first_name}</span>
                )}
                {!isCollapsed && <svg
                    className={`w-5 h-5 transition-transform duration-500 ${open ? "rotate-180" : "rotate-[270deg]"}`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ pointerEvents: "none" }}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>}
            </button>

            {/* Menú desplegable */}
            {open && (
                <div
                    ref={menuRef}
                    className="absolute left-1/2 bottom-full transform -translate-x-1/2 -translate-y-2 w-48 bg-[#26262D] text-white shadow-lg rounded-lg p-3 space-y-2 z-[9999]"
                >
                    <button className="w-full text-left p-2 hover:bg-[#2f2f36] rounded whitespace-nowrap">
                        Perfil
                    </button>
                    <button className="w-full text-left p-2 hover:bg-[#2f2f36] rounded whitespace-nowrap">
                        Configuración
                    </button>
                    <button className="w-full text-left p-2 hover:bg-[#2f2f36] rounded whitespace-nowrap" onClick={() => SignOut()}>
                        Cerrar sesión
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserMenu;